import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { CountryDto } from '../types/CountryDto';
import { merge, Observable, Subject } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
} from 'rxjs/operators';
import { FormGroup } from '@angular/forms';
import { NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'lp2-typeahead-dropdown',
  templateUrl: './typeahead-dropdown.component.html',
  styleUrls: ['./typeahead-dropdown.component.scss'],
})
export class TypeaheadDropdownComponent implements OnInit {
  @Input()
  entries: any[] = [];

  @Input()
  form: FormGroup;

  @Input()
  controlName: string;

  @Input()
  itemIdProperty: string;

  @Input()
  formatPropertyName: string;

  @Output()
  selectedValue = new EventEmitter();

  @ViewChild('instance')
  instance: NgbTypeahead;

  itemModel;

  dropInterval;

  isWriting = false;

  focus$ = new Subject<string>();

  click$ = new Subject<string>();

  ngOnInit() {
    if (this.form) {
      this.form.get(this.controlName).valueChanges.subscribe((value) => {
        this.itemModel = value;
      });
    }
  }

  keyDownEvent(event: KeyboardEvent) {
    // Check if the user is writing to filter the options list
    switch (event.key) {
      case 'ArrowDown':
      case 'ArrowUp':
      case 'Enter':
        return;
    }

    this.isWriting = true;
  }

  selectedEntry(event) {
    this.isWriting = false;
    this.form.get(this.controlName).setValue(event.item);
    this.form.get(this.controlName).markAsDirty();
    this.selectedValue.emit(event.item);
  }

  onBlurDropdown() {
    this.isWriting = false;
    this.form.get(this.controlName).markAsTouched();

    // Reset to our desired format if the user manually edit the value
    if (this.dropInterval) {
      clearInterval(this.dropInterval);
    }
    this.dropInterval = setInterval(() => {
      if (
        !(
          this.instance &&
          this.instance.isPopupOpen() &&
          this.itemModel &&
          this.itemModel[this.itemIdProperty]
        )
      ) {
        clearInterval(this.dropInterval);
        this.itemModel = this.form.get(this.controlName).value;
      }
    }, 500);
  }

  formatter = (result: CountryDto) => result[this.formatPropertyName];

  search = (text$: Observable<string>) => {
    const debouncedText$ = text$.pipe(
      debounceTime(200),
      distinctUntilChanged()
    );
    const clicksWithClosedPopup$ = this.click$.pipe(
      filter(() => !this.instance.isPopupOpen())
    );

    const focus$ = this.focus$;

    return merge(debouncedText$, focus$, clicksWithClosedPopup$).pipe(
      map((term) =>
        term === '' || !this.isWriting
          ? this.entries
          : this.entries.filter(
              (v) =>
                v[this.formatPropertyName]
                  .toLowerCase()
                  .indexOf(term.toLowerCase()) > -1
            )
      )
    );
  };
}



// WEBPACK FOOTER //
// ./ts/app/shared/typeahead-dropdown/typeahead-dropdown.component.ts